<template>
  <v-app class="g-app" id="app">
    <cmpHeader></cmpHeader>
    <v-main :class="{'app-mobile': $vuetify.breakpoint.mobile}" style="padding:0">
      <v-container fluid>
        <!-- 如果使用 vue-router -->
        <router-view></router-view>
      </v-container>
      <!-- <router-view></router-view> -->
    </v-main>
    <cmpFooter></cmpFooter>
  </v-app>
</template>

<script>
import cmpHeader from '@cmp/header'
import cmpFooter from "@cmp/footer";
export default {
  name: 'App',
  components: { cmpHeader, cmpFooter },
  data: () => ({
    //
  }),
  mounted(){
    
  }
};
</script>

<style lang="scss">
// @import '@assets/css/theme.scss';
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  ::-webkit-scrollbar {
    width: 0 !important;height: 0;
  }
  html{
    font-size: 16px;
  }
  @media screen and (max-width: 540px){
    html{
        font-size: 7px!important;
    }
  }
</style>
